import { Appbar, IconButton } from 'react-native-paper'
import { StackHeaderProps, StackNavigationProp } from '@react-navigation/stack'
import { AppNavigation, AppNavigatorParams } from '../../../navigation/types'
import { View } from 'react-native'
import NodeSelector from './shared/node.selector'
import { useNode } from '../../../contexts/current-node.provider'
import NavigationBarMenu from '../../../@ui/headers/components/navigation.header'
import { useTheme } from '../../../hooks/theme.hook'
import { MyCoRank } from '../../../@ui/buttons/corank.button'
import { MelddToolTip } from '../../../utils/meldd-tooltip'
import { useTranslation } from 'react-i18next'
import { useAuthContext } from '../../../contexts/auth-context'
import AnonymousBarMenu from '../../../@ui/headers/components/anonymous-menu.header'
import { useNavigation, useRoute } from '@react-navigation/native'
import { useAvailableNodesQuery } from '../../../generated/graphql'
import { IconSearch } from '../../../utils/meldd-icons'
import { ScrollView } from 'react-native-gesture-handler'
import { useIsMobileDevice } from '../../../hooks/is-mobile.hook'
import { getReturnPath } from '../../../navigation/build-return-path'
import { DecisionsButton } from '../contributions/components/decisions.button'
import { Row } from '../../../@ui'
export interface NodeNavigationBarProps extends StackHeaderProps {
  navigation: StackNavigationProp<AppNavigatorParams>
}

const LoginButton = () => {
  const navigation = useNavigation<AppNavigation>()
  return (
    <View>
      <IconButton
        onPress={() =>
          navigation.navigate('LoginMobileNumber', {
            returnPath: getReturnPath(navigation),
          })
        }
        icon="login"
        size={24}
      />
    </View>
  )
}

export function NodeNavigationBar({ navigation }: NodeNavigationBarProps) {
  const theme = useTheme()
  const { currentNode, loading: loadingNode } = useNode()
  const { t } = useTranslation('header')
  const { isAnonymous } = useAuthContext()
  const isMobile = useIsMobileDevice()
  const { data, loading } = useAvailableNodesQuery({
    fetchPolicy: 'cache-and-network',
  })
  const route = useRoute()
  const isSearchScreen = route.name === 'Search'
  return (
    <Appbar.Header style={{ backgroundColor: theme.colors.secondaryContainer }}>
      <View
        style={{
          flex: 1,
          marginHorizontal: 12,
          flexDirection: 'row',
          flexWrap: 'nowrap',
          alignItems: 'center',
        }}
      >
        <View style={{ maxWidth: 300 }}>
          <NodeSelector
            loading={loading || loadingNode}
            selected={currentNode}
            nodes={data?.availableNodes || []}
            onSelect={(node) => navigation.setParams({ nodeId: node.id })}
          />
        </View>
        {currentNode && (
          <ScrollView horizontal={true}>
            {currentNode.isPrivate && (
              <MelddToolTip title={t('private')}>
                <IconButton icon={'lock-outline'} />
              </MelddToolTip>
            )}
            {!isSearchScreen && (
              <MelddToolTip title={t('search')}>
                <IconButton
                  icon={IconSearch}
                  onPress={() =>
                    navigation.navigate('Search', { nodeId: currentNode.id })
                  }
                />
              </MelddToolTip>
            )}
            {isMobile && (
              <View style={{ marginTop: 5 }}>
                <MyCoRank />
              </View>
            )}
            {isMobile && <DecisionsButton />}
            <MelddToolTip title={t('info')}>
              <IconButton
                icon="chart-bar"
                onPress={() =>
                  navigation.push('NodeStats', { nodeId: currentNode.id })
                }
              />
            </MelddToolTip>
          </ScrollView>
        )}
      </View>
      {isAnonymous ? (
        <>
          {!isMobile && <LoginButton />}
          <AnonymousBarMenu navigation={navigation} />
        </>
      ) : (
        <>
          {!isMobile && (
            <Row alignItems="center" columnGap={4}>
              <MyCoRank />
              <DecisionsButton />
            </Row>
          )}
          <NavigationBarMenu navigation={navigation} />
        </>
      )}
    </Appbar.Header>
  )
}
